import { IActivityNavItem } from '../common/activity_nav/interface'
import { IGetGroupActivityListRes, IActivityDetailRes, IActivityDetail } from './interface'

class Format {
    public static groupActivityListToActivityNav(GgoupActivityList: IGetGroupActivityListRes, groupId: number): IActivityNavItem[] {
        const activityNavList: IActivityNavItem[] = []
        Array.isArray(GgoupActivityList.list) && GgoupActivityList.list.forEach(item => {
            activityNavList.push({
                key: item.id,
                name: item.name,
                href: `/group/${groupId}/detail/${item.id}`
            })
        })
        return activityNavList
    }

    public static activityDetail(detail: IActivityDetailRes): IActivityDetail {
        let result: IActivityDetail
        result = {
            coverImage: detail.cover_image,
            sharePictureURL: detail.share_picture_url,
            name: detail.name,
            brief: detail.brief,
            restVoteCount: detail.max_num - detail.voted_num,
            deadline: detail.deadline,
            searchWords: detail.search_words,
            options: []
        }
        Array.isArray(detail.options) && detail.options.forEach(item => {
            result.options.push({
                id: item.id,
                name: item.name,
                shortName: item.short_name,
                url: item.url,
                voteNum: item.vote_num,
                voteList: item.vote_list,
                disableVote: item.disable_vote,
                voteAvatarUrlList: []
            })
        })
        return result
    }
}

export {
    Format
}


// WEBPACK FOOTER //
// ./src/components/activity_detail/helper.ts